export const ARTICLE_SCROLL_THRESHOLDS = [25, 50, 75, 100] as const;

export type TArticleScrollThreshold = (typeof ARTICLE_SCROLL_THRESHOLDS)[number];

/**
 * Доля высоты текста статьи, которая уже побывала в окне: 0 — до текста
 * ещё не долистали, 100 — нижний край текста достиг низа окна или выше.
 */
export const getArticleScrollPercent = (element: HTMLElement, viewportHeight: number): number => {
  const { height, top } = element.getBoundingClientRect();

  if (height <= 0 || viewportHeight <= 0) {
    return 0;
  }

  return Math.max(0, Math.min(100, ((viewportHeight - top) / height) * 100));
};

export const getReachedArticleScrollThresholds = (
  percent: number,
  alreadySent: ReadonlySet<TArticleScrollThreshold>,
): TArticleScrollThreshold[] =>
  ARTICLE_SCROLL_THRESHOLDS.filter(threshold => percent >= threshold && !alreadySent.has(threshold));
